import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'app/redux/store';
import { getWidgetProgressAction } from 'app/redux/actions/NavHeaderAction';
import './WidgetProcessBulkFunding.scss';

export interface InfoCardTextLabel {
	title: string;
	value: string;
}
export interface TextLabelCard {
	data: InfoCardTextLabel[];
	loading: boolean;
}

const WidgetProcessBulkFunding = function init(): React.ReactElement {
	const dispatch = useDispatch();
	const navHeaderData = useSelector((state: RootState) => state.navHeaderReducer);
	const widgetData = navHeaderData?.widgetProgressAction;
	const currentProcess = widgetData?.data?.qtyCurrentProcess;
	const loanFunded = widgetData?.data?.qtyLoanFunded;

	const handleRefresh = (): void => {
		dispatch(getWidgetProgressAction());
	};

	const calculatePercentage = (): number | string => {
		if (!currentProcess || !loanFunded) {
			return '-';
		}

		const currentProcessNum = currentProcess;
		const loanFundedNum = loanFunded;

		return (loanFundedNum === 0) ? '-' : (currentProcessNum / loanFundedNum) * 100;
	};

	return (
		<div className="root">
			<div className="space">
				<div className="container-us">
					<div className="status-label">On Progress</div>
				</div>
				<div>
					<button type="button" className="refresh" onClick={handleRefresh}> &#10227; Refresh</button>
				</div>
			</div>
			<div className="space">
				<div className="container-us">
					<div>Pendanaan Bulk</div>
				</div>
				<div className="container-us">
					<div>
						{calculatePercentage()}
						%
					</div>
				</div>
			</div>
			<div className="space">
				<progress id="file" max={loanFunded} value={currentProcess} className="progress-bar-inside">
					70%
				</progress>
			</div>
			<div className="space-right-container">
				<div className="space-right">
					<div className="container-us">
						<div>
							{widgetData?.data?.qtyCurrentProcess}
							/
							{widgetData?.data?.qtyLoanFunded}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WidgetProcessBulkFunding;
